import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import { UiLanguageProvider } from "./lib/LocaleProvider";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <UiLanguageProvider>
      <App />
    </UiLanguageProvider>
  </StrictMode>,
);
